import { useCallback } from 'react';
import { getAppUpdateService } from '../service/ServiceRegistry';
import type { FetchDataFn, TableQueryParams, TableDataResponse } from '../types/table';
import type { AppUpdate, AppUpdatesQueryParams } from '../types/api/app-update';

export function useAppUpdates() {
  const appUpdateService = getAppUpdateService();

  const fetchAppUpdates: FetchDataFn<AppUpdate> = useCallback(
    async (params: TableQueryParams): Promise<TableDataResponse<AppUpdate>> => {
      try {
        const apiParams: AppUpdatesQueryParams = {
          page: params.page,
          size: params.pageSize,
        };

        const response = await appUpdateService.getAppUpdates(apiParams);

        return {
          data: response.items,
          pagination: {
            page: response.page,
            pageSize: response.size,
            total: response.totalItems,
            totalPages: response.totalPages,
            hasNext: response.hasNext,
            hasPrev: response.hasPrevious,
          },
        };
      } catch (error) {
        console.error('Failed to fetch app updates:', error);
        throw new Error('Failed to load app updates. Please try again.');
      }
    },
    [appUpdateService]
  );

  return {
    fetchAppUpdates,
  };
}

